export const mutations = {
  setUserData(state, data) {
    state.userData = data;
  },
  setConnectionStatus(state, data) {
    state.connectionStatus = data;
  },
  setQueue(state, data) {
    state.queue = data;
  },
  setLoad(state) {
    state.load = true;
  },
  setTags(state, data) {
    state.tags = data;
  },
  setCategories(state, data) {
    state.categories = data;
  },
  setExpressStatuses(state, data) {
    state.expressStatuses = data;
  },
  setExpressRegional(state, data) {
    state.expressRegional = data;
  },
  setExpressAssociate(state, data) {
    state.expressAssociate = data;
  },
  setExpressBilletSituation(state, data) {
    state.expressBilletSituation = data;
  },
  setUserMessage(state, data) {
    state.userMessage = data;
  },
  setNewConnectionWapi(state, data) {
    state.newConnectionWapi = data;
    state.userData = {
      ...state.userData,
      device_id: data.id,
    };
  },
};
